import { render } from "./Neurology.vue?vue&type=template&id=1fba105e"
import script from "./Neurology.vue?vue&type=script&lang=ts"
export * from "./Neurology.vue?vue&type=script&lang=ts"
script.render = render

export default script